import { moduleProviderFactory } from "core/providers";
import { NikoFacilityOrderOrderSummaryPreview } from "application/niko-facility-order-order-summary/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.niko-facility-order",
                pattern: "/niko-facility-orders",
                children: [
                    {
                        name: "master.app.main.niko-facility-order.order-summary-preview",
                        pattern: "/:id/order-summary",
                        authorization: "administrationSection.read",
                        component: NikoFacilityOrderOrderSummaryPreview,
                        data: {
                            //title: "",
                            crumbs: [
                                {
                                    title: "FACILITY_ORDER.CRUMB.ORDER_SUMMARY",
                                    route: 'master.app.main.niko-facility-order.order-summary-preview'
                                }
                            ],
                            back: "master.app.main.niko-facility-order.list",
                        }
                    },		
                ]
            }
        ],
        menu: [
            {
                title: "MENU.FACILITY_ORDERS",
                icon: "package",
                authorization: "administrationSection.read",
                order: 5,
                subMenu: [
                    {
                        title: "MENU.NIKO_FACILITY_ORDERS",
                        authorization: "administrationSection.read",
                        route: "master.app.main.niko-facility-order.list",
                        order: 3,
                    }
                ]
            },
        ]
    });
})();